// extracted by mini-css-extract-plugin
module.exports = {"text":"text-bold-l_text__2w-F9"};